// extracted by mini-css-extract-plugin
module.exports = {"container":"modal-container__2f0h3","title":"modal-title__1hdEH","cross":"modal-cross__24fpP","content":"modal-content__1S9QL","loader":"modal-loader__2zJPR"};